<template>
  <div class="cards-grid__wrapper">
    <v-card
      v-for="(item, index) in items"
      :key="index"
      color="strong"
      class="px-5 pt-5 pb-3 elevation-1"
    >
      <div class="card-grid--content">
        <strong class="mb-2" style="font-size: 16px;">
          <slot name="title" v-bind="item">
            {{ item.title }}
          </slot>
        </strong>
        <p>
          <slot name="description" v-bind="item">
            {{ item.description }}
          </slot>
        </p>
      </div>
      <div class="text-right">
        <slot name="button" v-bind="item">
          <v-btn
            color="accent"
            text
            @click.native="$emit('click-button', item)"
          >
            <span style="font-size: 16px;font-weight: normal;">
              <slot name="button.content" v-bind="item">
                {{ $t("common:navigate.button") }}
                <v-icon right style="font-size: 15px">
                  <slot name="button.icon" v-bind="item">
                    $iconArrowOutSquare</slot
                  >
                </v-icon>
              </slot>
            </span>
          </v-btn>
        </slot>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "AppCardsGrid",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
.cards-grid__wrapper {
  display: grid;
  grid-column-gap: 16px;
  grid-row-gap: 2em;
  grid-template-columns: repeat(auto-fit, 335px);

  padding: 8px;
  @media (max-width: 768px) {
    justify-content: center;
  }
  .v-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .card-grid--content {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
